import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';

interface ResultState {
  resultImportProduct: any;
}

const initialState: ResultState = {
  resultImportProduct: {
    "numOfImports": "0",
    "successImportProducts": "0",
    "successUpdateProducts": "0",
    "failedImportProducts": [],
    "duplicateImportProducts": [],
  }
}

export const resultImportProductSlice = createSlice({
  name: 'resultImportProduct',
  initialState,
  reducers: {
    clear: () => initialState,
    setResult: (state, action) => {
      if (action.payload != 1) {
        state.resultImportProduct = action.payload;
      } else {
        clear();
      }
    },
  }
})

export const {
  setResult,
  clear
} = resultImportProductSlice.actions

export default resultImportProductSlice.reducer
